<template>
  <div>
      <h1>Person Dashboard</h1>
  </div>
</template>
<script setup></script>  